import React from 'react'
import './ActivityIndicator.css'

const ActivityIndicator = () => <div className="lds-dual-ring"></div>

export default ActivityIndicator
